import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Container as SemanticContainer } from 'semantic-ui-react';
import i18next from 'i18next';
import { graphql } from 'react-relay';

import { scrollHtmltoTop } from '~/modules/core/utils/jsHelpers/ScrollToTop';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import ShopsReviews from '~/modules/ecommerceShops/containers/ShopsReviews';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import FloatingIcon from '~/modules/ecommerceOrder/containers/customerService/FloatingIcon';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';

import BestSeller from './BestSeller';
import ShopDetailsHeader from './ShopDetailsHeader';
import ShopTracks from './ShopTracks';
import ShopInfo from '../shopInfoProvider/ShopInfo';
import ShopDetailsBreadcrumbs from '~/modules/ecommerceCoreUI/components/breadcrumbs/ShopDetailsBreadcrumbs';
import withRootQuery from '~/modules/core/utils/relayHelpers/withRootQuery';
import withUserInfo from '~/modules/core/utils/accessManagementHelpers/withUserInfo';

class ShopDetailsPage extends Component {
  componentDidMount() {
    scrollHtmltoTop();
  }

  render() {
    return (
      <React.Fragment>
        <ShopDetailsBreadcrumbs />
        <ShopDetailsHeader vendorID={this.props.match.params.vendorID} />
        {this.props.queryResult?.shop?.active && (
          <React.Fragment>
            {this.props.authenticated && (
              <FloatingIcon
                url={urlFor('getAskShopLink', [this.props.match.params.vendorName, this.props.match.params.vendorID])}
                title={i18next.t('eCommerceShops:ShopDetails.askShopLink')}
              />
            )}
            <ShopTracks vendorID={this.props.match.params.vendorID} vendorName={this.props.match.params.vendorName} />
            <BestSeller
              vendorID={this.props.match.params.vendorID}
              vendorName={this.props.match.params.vendorName}
            />
          </React.Fragment>
        )}
        <SemanticContainer>
          <ShopsReviews
            vendor_id={this.props.match.params.vendorID}
          />
        </SemanticContainer>
        <Separator customColorTone="#f9f9f9" separatorLength="full" separatorWeight={1.5} spacerSize={[1.5, 1.5, 2.5]} />
        {/* shopInfoSection class in used to scroll to section , don't change */}
        <div className="shopInfoSection">
          <ShopInfo vendorID={this.props.match.params.vendorID} />
        </div>
        <Spacer size={3.5} />
      </React.Fragment>
    );
  }
}

ShopDetailsPage.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      trackId: PropTypes.string,
      vendorID: PropTypes.string,
      vendorName: PropTypes.string,
    }).isRequired,
  }).isRequired,
  queryResult: PropTypes.shape({
    shop: PropTypes.shape({
      active: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

export default translate('eCommerceShops')(withUserInfo(withRouter(withRootQuery(
  ShopDetailsPage,
  graphql`
      query ShopDetailsPageQuery($vendorID: ID!) {
        shop(id: $vendorID) {
          ref_id
          id
          active
        }
      }
    `,
  null,
  props => ({
    vendorID: props.match.params.vendorID,
  }),
))));
